import React from 'react';
export const HeroSection = () => {
  return <section id="hero" className="w-full bg-green-900/10 py-8" data-id="element-151">
      <div className="container mx-auto px-4" data-id="element-152">
        <div className="flex flex-col md:flex-row items-center gap-6" data-id="element-153">
          <div className="w-full md:w-1/2" data-id="element-154">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/dTJiacnhJdZ8oW4yF5U9AR/ChatGPT_Image_20_de_jul._de_2025%2C_15_21_15.png" alt="Golden retriever looking at The Daily Foundation Chew product with a bowl of supplement chews" className="rounded-lg w-full" data-id="element-155" />
          </div>
          <div className="w-full md:w-1/2" data-id="element-156">
            <h1 className="text-2xl md:text-3xl font-bold text-green-900 mb-4" data-id="element-157">
              Dogs All Across America Silently Cope With Poor Gut Health. See
              Why Over 2 Million Owners Have Turned to This New Probiotic Chew
              for Help.
            </h1>
            <p className="text-green-900/80 mb-6" data-id="element-158">
              Every 14 seconds, another U.S. dog owner finds their dog suffering
              from itchy skin, digestive issues, low energy, or joint stiffness
              – all symptoms of the same hidden problem.
            </p>
            <a href="#gut-health" className="bg-yellow-700 hover:bg-yellow-800 text-amber-50 font-bold py-3 px-8 rounded-full text-lg shadow-md transition duration-300 inline-block" data-id="element-159">
              LEARN MORE
            </a>
          </div>
        </div>
      </div>
    </section>;
};